import config from 'services/table/const';
import Action from './table.action';
import * as Fi from 'react-icons/fi';

let table = { ...config };

table.url = '/location/hub';
table.columns = {
    name: {
        title: 'Nama',
        sortable: true,
        width: 350,
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                        {row?.name}
                    </div>
                    <small className="text-ellipsis info fw-semibold text-uppercase">
                        {`${row?.region?.district_name}, ${row?.region?.regency_name}, ${row?.region?.province_name}`}
                    </small>
                    <small className="info text-uppercase">CP: {row?.contact_person}</small>
                    <small className="info text-uppercase">PHONE: {row?.phone_number}</small>
                </div>
            );
        },
    },
    hub_default: {
        title: 'Hub Utama',
        width: 100,
        class: 'text-center',
        classHeader: 'text-center',
        component: (row) => {
            return row?.hub_default ? <Fi.FiCheck size={24} color="#2fb344" className="me-2" /> : null;
        },
    },

    action: {
        title: '',
        width: 40,
        class: 'text-end',
        component: (row) => {
            return <Action data={row} />;
        },
    },
};

export default table;
